export function getListIds(...list) {
  return list.map((title, i) => ({
    title,
    id: i + 1,
  }))
}
